import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  children: {
    cursor: 'pointer'
  },

  menu: {
    position: 'fixed',
    top: '0',
    left: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100vw',
    height: ({ height }) => `calc(${height})`,
    background: 'white',
    zIndex: '100'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid lightgray',
    boxSizing: 'border-box',
    width: 'calc(100% - 2rem)',
    padding: '0.5rem',
    fontSize: theme.size.base
  },

  close: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },

  items: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    width: '100%',
    paddingBottom: '0.5rem',
    overflow: 'hidden auto'
  },

  moreBlock: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },

  more: {
    margin: '0',
    width: '100%',

    '& > div': {
      paddingTop: '0.75rem'
    }
  }
}))

export default useStyles
